import React from 'react';
import { useScreenContext } from '../utils/hooks/useScreenContext.js';

const defaultData = {
  screenSize: 'xxl',
  skeletonStore: {
    get: () => undefined,
    register: () => undefined,
    subscribe: () => undefined
  }
};
const ScreenSizeContext = React.createContext(defaultData);
const ScreenSizeProvider = ({
  children
}) => {
  const context = useScreenContext();
  return React.createElement(ScreenSizeContext.Provider, {
    value: context
  }, children);
};
ScreenSizeProvider.displayName = 'ScreenSizeProvider';
var ScreenSizeProvider$1 = ScreenSizeProvider;

export { ScreenSizeContext, ScreenSizeProvider$1 as default };
//# sourceMappingURL=ScreenSizeProvider.js.map
